// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__2mR-a","title":"AfterImages45_title__1JA_G","images":"AfterImages45_images__2GCdO"};